module.exports = __webpack_public_path__ + "img/default.df39b032.png";